const { DateTime, Interval } = require("luxon");
const uniqWith = require("lodash/uniqWith");
const isEqual = require("lodash/isEqual");

const { SLOT_BLOCK_REASON } = require("../constants");
const getAllSlots = require("./getAllSlots");

function filterPast(date, slots) {
  const now = DateTime.local();
  const theDate = DateTime.fromJSDate(date);
  const isNow =
    now.hasSame(theDate, "year") &&
    now.hasSame(theDate, "month") &&
    now.hasSame(theDate, "day");
  return slots.filter((item) => {
    if (isNow) {
      const slotTime = item.start;
      return slotTime > now;
    }
    return true;
  });
}

function filterFuture(date, slots) {
  const endOftheDate = DateTime.fromJSDate(date).endOf("day");

  return slots.filter((item) => {
    const slotTime = item.start;
    const test = slotTime > endOftheDate;
    return !test;
  });
}

function filterDay(date, slotsArr) {
  let slots = [...slotsArr];
  slots = filterPast(date, slots);
  slots = filterFuture(date, slots);
  return slots;
}

function getInterval(startTime, duration, endTime) {
  const start = startTime;
  const end = endTime
    ? endTime
    : start.plus({
        minutes: duration,
      });

  return Interval.fromDateTimes(start, end);
}

// If the conflicting slot is closed (but the test slot is available), mark this slot as being too close to when the restaurant is closed
function getReason(slot) {
  if (!slot) return null;
  if (slot.reason === SLOT_BLOCK_REASON.CLOSED)
    return SLOT_BLOCK_REASON.BOOKING_DURATION_LIMIT;
  return slot.reason;
}

function markOverlappedScheduleSlots(slots, durationOfBooking) {
  const slotsOrig = [...slots];
  return slots.map((reservation) => {
    if (!reservation.available) return reservation;
    const reservationInterval = getInterval(
      reservation.start,
      durationOfBooking
    );

    const unavailableSlot = slotsOrig.find((slot) => {
      const slotInterval = getInterval(slot.start, null, slot.end);
      const overlaps = reservationInterval.overlaps(slotInterval);
      return overlaps && !slot.available;
    });

    const reason = getReason(unavailableSlot);
    const obj = {
      ...reservation,
      available: !unavailableSlot,
      ...(reason && { reason }),
    };
    return obj;
  });
}

module.exports = async (firebase, business, date, duration) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + 1);
  const slots1 = await getAllSlots(firebase, business, date);
  const slots2 = await getAllSlots(firebase, business, nextDate);
  let slots = [...slots1, ...slots2];
  slots = markOverlappedScheduleSlots(slots, duration);
  slots = slots.reduce(
    (accumulator, currentValue) => accumulator.concat(currentValue),
    []
  );
  slots = filterDay(date, slots);
  slots = uniqWith(slots, isEqual);

  return slots;
};
